// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3q7Qm","content":"styles_content__33Xe3","selectAll":"styles_selectAll__1H1zS"};